<template>
  <div class="groupon-detail-wrapper" v-if="grouponDetail != null">
    <div class="header-wrapper">
      <h3 class="title">{{shopInfo.name}} / 团购管理 / {{grouponDetail.name}} ({{grouponDetail.status | grouponStatus}})</h3>
    </div>
    <h2>团购信息</h2>
    <table class="groupon-detail-table">
      <tbody>
        <tr>
          <td>名称</td>
          <td>{{grouponDetail.name}}</td>
        </tr>
        <tr>
          <td>描述</td>
          <td>
            <div v-for="(desc, index) in grouponDescriptions">
              <div v-if="desc.type === 1">
                <div>{{desc.text}}</div>
              </div>
              <div class="groupon-detail-img" v-else-if="desc.type === 2">
                <img :src="desc.text | ossurl" alt="">
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td>开始时间</td>
          <td>{{grouponDetail.start_time | dateTimeFormatter('yyyy-MM-dd')}}</td>
        </tr>
        <tr>
          <td>开始时间</td>
          <td>{{grouponDetail.end_time | dateTimeFormatter('yyyy-MM-dd')}}</td>
        </tr>
        <tr v-for="(product, index) in grouponDetail.products">
          <td>商品名称{{index + 1}}</td>
          <td>{{product.name}}</td>
        </tr>
      </tbody>
    </table>

    <br>

    <h2 style="display:inline;">报名信息</h2>
    <el-tag>共有{{grouponEnrolls.length}}参与了团购</el-tag>
    <el-button type="text" @click="smsDialogVisible = true">(群发短信)</el-button>
    <el-dialog title="群发短信" :visible.sync="smsDialogVisible">
      <el-form :model="smsDialogForm" ref="smsDialogForm" :rules="smsDialogRules" label-width="80px" >
        <el-form-item label="短信内容" prop="content">
          <el-input type="textarea" v-model="smsDialogForm.content"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelSendGrouponSms('smsDialogForm')">取 消</el-button>
        <el-button type="primary" @click="sendGrouponSms('smsDialogForm')">发 送</el-button>
      </div>
    </el-dialog>

    <el-table
      :data="grouponEnrolls"
      border
      show-summary
      :summary-method="summaryData"
      style="max-width: 100%">
      <el-table-column
        label="ID"
        align="center"
        width="60">
        <template slot-scope="scope">
          {{scope.row.enroll_order}}
        </template>
      </el-table-column>
      <el-table-column
        label="姓名"
        align="center"
        width="140">
        <template slot-scope="scope">
          {{scope.row.user.name}}
        </template>
      </el-table-column>
      <el-table-column
        prop="phone"
        label="电话"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="comment"
        align="center"
        label="备注">
      </el-table-column>
      <el-table-column
        prop="address"
        align="center"
        label="地址">
      </el-table-column>
      <el-table-column
        align="center"
        label="团购商品">
          <el-table-column v-for="(product, index) in grouponDetail.products" :key="product.id"
            :label="product.name"
            align="center"
            :column-key="product.id.toString()">
            <template slot-scope="scope">
              {{ scope.column.columnKey | getAmount(scope.row) }}
            </template>
          </el-table-column>
      </el-table-column>
      <el-table-column
        label="金额"
        align="center"
        width="100">
        <template slot-scope="scope">
          {{ scope.row | getMoney }}
        </template>
      </el-table-column>
    </el-table>

    <div class="page-block">
      <el-pagination
        @current-change="currentPageChanged"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>

  </div>
</template>

<script>
import NProgress from 'nprogress'

export default {
  name: 'shop-groupon-detail',
  data () {
    return {
      smsDialogVisible: false,
      smsDialogForm: {
        content: ''
      },
      smsDialogRules: {
        content: [
          {required: true, message: '请输入短信内容', trigger: 'blur'},
          {max: 1600, message: '短信长度不超过 1600 个字符', trigger: 'change'}
        ]
      },
      grouponEnrolls: [],
      loading: false,
      orderList: [],
      currentPage: 1,
      totalPage: null,
      totalCount: 0,
      pageSize: 100
    }
  },
  computed: {
    shopInfo () {
      return this.$store.getters['shop/shopInfo']
    },
    grouponDetail () {
      let grouponInfo = this.$store.state.shop['grouponDetail']
      if (!grouponInfo) {
        return {}
      }
      grouponInfo.products.sort((pre, next) => pre.id > next.id)
      return grouponInfo
    },
    grouponDescriptions () {
      let desc = [{
        type: 1,
        text: this.grouponDetail.description
      }]
      if (typeof this.grouponDetail.description === 'string') {
        try {
          desc = JSON.parse(this.grouponDetail.description)
        } catch (e) {
        }
      }
      return desc
    }
  },
  filters: {
    getAmount (id, enroll) {
      id = Number(id)
      let product = enroll.products.find(product => product.id === id)
      return product ? product.amount : ''
    },
    getMoney (enroll) {
      return enroll.products.reduce((total, product) => total + product.amount * product.price, 0)
    }
  },
  mounted () {
    NProgress.start()
    this.$store.commit('shop/setShopId', Number(this.$route.params.sid))
    this.$store.dispatch('shop/fetchGrouponDetail', Number(this.$route.params.gid)).then(resp => {
      NProgress.done()
      this.currentPageChanged()
    }).catch((err) => {
      NProgress.done()
      console.error(err)
    })
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('shop/setGrouponDetail', null)
    next()
  },
  methods: {
    summaryData ({columns, data}) {
      let result = ['合计', '', '', '', '']
      var counts = {}
      let cols = columns.filter(col => col.columnKey)
      let money = 0
      data.forEach(enroll => {
        enroll.products.forEach(product => {
          counts[product.id.toString()] = counts[product.id.toString()] ? counts[product.id.toString()] + product.amount : product.amount
          money += product.amount * product.price
        })
      })
      cols.forEach(column => {
        result.push(counts[column.columnKey] ? counts[column.columnKey] + '件' : '0件')
      })
      result.push(money)
      return result
    },
    cancelSendGrouponSms (form) {
      this.smsDialogVisible = false
      this.smsDialogForm.content = ''
      this.$refs[form].resetFields()
    },
    sendGrouponSms (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.$store.dispatch('sendGrouponSms', {
            grouponId: this.$route.params.gid,
            content: this.smsDialogForm.content
          }).then(resp => {
            if (resp.errcode === 0) {
              this.$notify.success({
                title: '成功',
                message: '短信已成功发出'
              })
            }
          }).catch((err) => {
            console.error(err)
          })
          this.smsDialogVisible = false
          this.smsDialogForm.content = ''
          this.$refs[form].resetFields()
        } else {
          return false
        }
      })
    },
    currentPageChanged () {
      this.loading = true
      this.$store.dispatch('shop/fetchGrouponEnrollInfo', {
        page: this.currentPage,
        size: this.pageSize,
        grouponId: Number(this.$route.params.gid)
      }).then((res) => {
        if (res.errcode) {
          return
        }
        this.currentPage = res.current_page
        this.totalPage = res.total_page
        this.totalCount = res.total_count
        this.grouponEnrolls = res.enrolls
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="sass">
.groupon-detail-wrapper
  padding: 20px;
  h2
    font-size: 16px;
    font-weight: bold;
    margin: 10px 0;
  .header-wrapper
    overflow: hidden;
    margin-bottom: 10px;
    .title
      font-size: 14px;
      line-height: 2;
      font-weight: bold;
      float: left;
  .groupon-detail-table
    width: 800px;
    border-collapse: collapse;
    border-spacing: 0;
    font-size: 14px;
    table-layout: fixed;
    td
      border: 1px solid rgb(223, 236, 232)
      padding: 5px 10px;
    td:first-child
      font-weight: bold;
      background: rgb(238, 246, 245);
    .groupon-detail-img
      text-align: center
  .page-block
    padding-top: 20px
    text-align: center
</style>



// WEBPACK FOOTER //
// groupon-detail.vue?36e28ebc